import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-credits-transfer-success',
    templateUrl: './credits-transfer-success.component.html',
    styleUrls: ['./credits-transfer-success.component.scss'],
    standalone: false
})
export class CreditsTransferSuccessComponent implements OnInit {
  @Output() navigateToInventory: EventEmitter<void> = new EventEmitter();
  @Output() navigateToHistory: EventEmitter<void> = new EventEmitter();
  @Output() navigateToTransfer: EventEmitter<void> = new EventEmitter();
  TransferSuccess!: object;

  constructor(private router: Router) {}

  ngOnInit() {
    document.getElementById('overlay')!.style.display = 'block';
  }
  /* istanbul ignore next */
  goToInventory() {
    this.navigateToInventory.emit();
  }
  /* istanbul ignore next */
  goToHistory() {
    this.navigateToHistory.emit();
  }

  goToTransfer() {
    this.navigateToTransfer.emit();
  }
}
